import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting';
import Theme from "highcharts/themes/grid-light";
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts);
Theme(Highcharts);

const PieChartv2Mini: any = (props: any) => {
    const { allData, colores } = props;

    const options = {
        chart: {
            backgroundColor: 'white',
            height: 300,
            width: 300,
            plotShadow: false,
            type: 'pie',
			
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        tooltip: {
            shared: true,
            useHTML: true,
            headerFormat: '<table><tr><th colspan="2">{point.key}:  <b>{point.y}%</b></th></tr>',
            pointFormat: '',
            footerFormat: '</table>',
            valueDecimals: 0
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
		plotOptions: {
			pie: {
				dataLabels: {
					enabled: true,
					fontFamily: 'Montserrat-SemiBold',
					// @ts-ignore
					formatter: function() {
						// Usa 'this.point.color' para obtener el color del punto
						// @ts-ignore
						return '<span style="fontFamily: Montserrat-SemiBold; fontSize: 8px; color:' + this.point.color + '">'+this.point.name+'<br/>'+ + this.point.percentage.toFixed(0) + '%'  +'</span>';
					},
					distance: 0,
					filter: {
						property: 'percentage',
						operator: '>',
						value: 4
					}
				},
				allowPointSelect: true,
				cursor: 'pointer',
				showInLegend: true
			}
		},
        credits: {
            enabled: false
        },
        series: [{ innerSize: '70%', data: allData }],
        colors: colores,
        legend: {
            enabled: false
        },
		exporting: {
            enabled: false
        }
    };

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </>
    );
}

export default PieChartv2Mini;